import {
    Divider, Text,
    VisuallyHidden
} from '@chakra-ui/react';
import React from 'react';

import { isDefined } from '../../../../helpers/utils';

interface MidMilestoneScreenProps {
    hasMilestoneSummary?: boolean
    header?: string
    header2?: string
    milestoneDescription?: string
    milestoneHeader?: string
    nextStageLabel?: string
    noPointsEarnTxt?: string
    numMilestoneQuestions?: number
    questionsTxt?: string
    questName?: string
    totalMilestonePoints?: number
    totalPointsTxt?: string
}

export const MidMilestoneScreen = ({
    hasMilestoneSummary,
    header,
    header2,
    milestoneDescription,
    milestoneHeader,
    nextStageLabel,
    noPointsEarnTxt,
    numMilestoneQuestions,
    questionsTxt,
    questName,
    totalMilestonePoints,
    totalPointsTxt
}: MidMilestoneScreenProps) => (
    <>
        <div className={'header-tab'} data-testid={'header-tab'}>
            <Text as={'h2'} className={'uow-topic'}>{questName}</Text>
        </div>
        <div className={'message-content'}>
            <div className={'message-body'}>
                {(isDefined(header)) &&
                    <h3 className={'header'} data-testid={'header'}>{header}</h3>
                }
                {(isDefined(header2)) &&
                    <h3 className={'header'} data-testid={'header2'}>{header2}</h3>
                }
                {nextStageLabel && <h3 className={'next-stage'}>{nextStageLabel}</h3>}
                <h3 className={'milestone-header'}>{milestoneHeader}</h3>
                <h3 className={'milestone-description'}>{milestoneDescription}</h3>
                {hasMilestoneSummary &&
                <div className={'milestone-summary'}>
                    <div className={'num-stack'}>
                        <div className={'num-stack_content'} data-testid={'questions'} aria-hidden={'true'}>
                            <div className={'num-label'}>{numMilestoneQuestions}</div>
                            <div className={'num-description'}>{questionsTxt}</div>
                        </div>
                        <VisuallyHidden id={'milestone-question-label'}>{`${numMilestoneQuestions} ${questionsTxt}`}</VisuallyHidden>
                    </div>
                    <Divider
                        borderColor={'neutral.100'}
                        h={'calc(100% - 2 * 20px)'}
                        my={'20px'}
                        opacity={1}
                        orientation={'vertical'}
                        aria-hidden={'true'}
                    />
                    <div className={'num-stack'}>
                        <div className={'num-stack_content'} data-testid={'total-points'} aria-hidden={'true'}>
                            <div className={'num-label'}>{totalMilestonePoints}</div>
                            <div className={'num-description'}>{totalPointsTxt}</div>
                        </div>
                        <VisuallyHidden id={'milestone-points-label'}>{`${totalMilestonePoints} ${totalPointsTxt}`}</VisuallyHidden>
                    </div>
                </div>
                }
                {noPointsEarnTxt &&
                    <Text color={'primary.600'} fontSize={18} mb={'4px'}>{noPointsEarnTxt}</Text>
                }
            </div>
        </div>
    </>
);
